import { render } from "./Agreement.vue?vue&type=template&id=05408df2"
import script from "./Agreement.vue?vue&type=script&lang=js"
export * from "./Agreement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v3/Agreement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05408df2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05408df2', __exports__)) {
    api.reload('05408df2', __exports__)
  }
  
  module.hot.accept("./Agreement.vue?vue&type=template&id=05408df2", () => {
    api.rerender('05408df2', render)
  })

}


export default __exports__